'use client';

import posthog from 'posthog-js';
import { PostHogProvider as PostHogProviderRaw } from 'posthog-js/react';
import type { ReactNode } from 'react';

type PostHogProviderProps = {
  readonly children: ReactNode;
};

// Let PostHogProviderRaw handle the initialization
export const PostHogProvider = (properties: PostHogProviderProps) => {
  // Disable PostHog completely in development
  if (process.env.NODE_ENV === 'development') {
    return <>{properties.children}</>;
  }

  // If PostHog env vars are not available, return children without analytics
  const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;

  if (!posthogKey || !posthogHost) {
    return <>{properties.children}</>;
  }

  return (
    <PostHogProviderRaw
      apiKey={posthogKey}
      options={{
        api_host: posthogHost,
        ui_host: posthogHost,
        person_profiles: 'identified_only',
        capture_pageview: false,
        capture_pageleave: true,
      }}
    >
      {properties.children}
    </PostHogProviderRaw>
  );
};

export const analytics = posthog;
